/* eslint-disable */
import { HiX } from "react-icons/hi";
import Links from "./Links";
import trTextImg from "assets/img/dashboards/Text-Logo-Colour-1.png";
import trTextLogoWhite from "assets/img/dashboards/TR-Text-Logo-White.png";
import { allRoutes, clientRoutes } from "routes";
import { useIsClientUser } from "app/hooks";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  const isClientUser = useIsClientUser();

  // For client users, only show client routes. For others, show all routes filtered by permissions
  const routesToShow = isClientUser ? clientRoutes : allRoutes;

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-[transform] dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 
      ${open ? "translate-x-0" : "-translate-x-96"} 
      w-[320px] min-w-[320px] max-w-[320px]`} 
    >
      {/* Added fixed width classes above: w-[320px] min-w-[320px] max-w-[320px] 
          This ensures the sidebar never expands even if text inside is long.
      */}

      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white">
          <img src={trTextImg} alt="Telerelation Logo" className="w-40 dark:hidden" />
          <img src={trTextLogoWhite} alt="Telerelation Logo" className="w-40 hidden dark:block" />
        </div>
      </div>

      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      
      {/* Nav item */}
      <ul className="mb-auto pt-1 h-[100vh] pb-80 overflow-y-scroll no-scrollbar">
        {/* Passing the routes to the Links component. 
            Inside Links.tsx, ensure you use whitespace-normal on the text 
            and state={{ isSidebar: true }} on the NavLink.
        */}
        <Links routes={routesToShow} />
      </ul>
      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;